"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputMapFindPlace = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faMapMarkerAlt_1 = require("@fortawesome/free-solid-svg-icons/faMapMarkerAlt");
const faCheckCircle_1 = require("@fortawesome/free-solid-svg-icons/faCheckCircle");
const react_markdown_1 = __importDefault(require("react-markdown"));
const remark_gfm_1 = __importDefault(require("remark-gfm"));
const project_config_1 = __importDefault(require("chaire-lib-common/lib/config/shared/project.config"));
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const react_i18next_1 = require("react-i18next");
const InputMapTypes_1 = require("./maps/InputMapTypes");
const InputSelect_1 = __importDefault(require("chaire-lib-frontend/lib/components/input/InputSelect"));
const HashLoader_1 = __importDefault(require("react-spinners/HashLoader"));
const SurveyErrorMessage_1 = __importDefault(require("../survey/widgets/SurveyErrorMessage"));
// TODO Allow to support multiple maps and geocoders
const InputMapGoogle_1 = __importDefault(require("./maps/google/InputMapGoogle"));
const GoogleGeocoder_1 = require("./maps/google/GoogleGeocoder");
// Path to default icons
// FIXME Use the icons from chaire-lib in `/dist/icons/` when it is possible to colorize them with proper styling
const defaultMarkerUrl = '/dist/images/activities_icons/default_marker.svg';
const defaultSelectedMarkerUrl = '/dist/images/activities_icons/default_selected_marker.svg';
// Default max zoom and zoom
const defaultZoom = 13;
const defaultMaxZoom = 18;
/**
 * Allow to select a single point from a map.
 *
 * TODO For now, it only uses google map, but this class should remain map
 * agnostic and support more map types
 *
 * TODO This was copy pasted from InputMapPoint and the methods were modified
 * with original InputMapFindPlace. We should try to re-use as much of the code
 * as possible. Main difference is that there can be multiple markers here and
 * it needs confirmation.
 */
class InputMapFindPlace extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.geocodeButtonRef = react_1.default.createRef();
        this.shouldFitBoundsIdx = 0;
        this.currentBounds = undefined;
        this.onValueChange = (feature) => {
            if (feature) {
                feature.geometry.coordinates = feature.geometry.coordinates.map((coordinate) => {
                    var _a;
                    return Number(coordinate.toFixed((_a = this.props.widgetConfig.coordinatesPrecision) !== null && _a !== void 0 ? _a : 5));
                });
            }
            this.props.onValueChange({ target: { value: feature } });
            this.setState({
                selectedPlace: undefined,
                defaultCenter: feature
                    ? { lat: feature.geometry.coordinates[1], lon: feature.geometry.coordinates[0] }
                    : this.state.defaultCenter
            });
        };
        this.onMapReady = (bbox) => {
            this.currentBounds = bbox;
            /*if (!this.props.value) { // does not work because map is not yet loaded at this point
                this.geocodePlaces(bbox);
            }*/
            // Do not render button until map is ready, to prevent flakiness when a test clicks the button too quickly.
            this.setState({ renderGeoCodeButton: true });
        };
        this.onBoundsChanged = (bbox) => {
            this.currentBounds = bbox;
        };
        this.onButtonFindPlaceClick = () => {
            this.geocodePlaces(this.currentBounds);
        };
        this.getGeocodingQueryString = () => {
            return this.props.widgetConfig.geocodingQueryString
                ? this.props.widgetConfig.geocodingQueryString(this.props.interview, this.props.path, this.props.user)
                : undefined;
        };
        this.getMaxGeocodingResultsBounds = () => {
            return this.props.widgetConfig.maxGeocodingResultsBounds
                ? this.props.widgetConfig.maxGeocodingResultsBounds(this.props.interview, this.props.path, this.props.user)
                : undefined;
        };
        this.setGeocodingOptions = (options) => {
            this.setState({ geocodingSpecificOptions: options });
        };
        this.geocodePlaces = (bbox) => __awaiter(this, void 0, void 0, function* () {
            const language = this.props.i18n.language;
            const geocodingQueryString = this.getGeocodingQueryString();
            const geocodingQueryStringArray = typeof geocodingQueryString === 'string'
                ? [{ queryString: geocodingQueryString, zoom: defaultZoom }]
                : geocodingQueryString;
            if (geocodingQueryStringArray) {
                try {
                    this.setState({ geocoding: true });
                    const getGeocodingResult = () => __awaiter(this, void 0, void 0, function* () {
                        // Try each geocoding query string until we get a result
                        for (let i = 0; i < geocodingQueryStringArray.length; i++) {
                            const features = (yield (0, GoogleGeocoder_1.geocodeMultiplePlaces)(geocodingQueryStringArray[i].queryString, Object.assign({ bbox,
                                language }, this.state.geocodingSpecificOptions))) || [];
                            if (features.length > 0) {
                                return {
                                    features,
                                    geocodingQueryString: geocodingQueryStringArray[i].queryString,
                                    zoom: geocodingQueryStringArray[i].zoom
                                };
                            }
                        }
                        return { features: [], zoom: defaultZoom };
                    });
                    const { features, geocodingQueryString, zoom } = yield getGeocodingResult();
                    const isSingleResult = features && features.length === 1;
                    // If there is only a single result, we check if it's precise enough using the location type information
                    // returned by the geocoding API.
                    // The Google Maps geocoding API returns an array of location types for each result.
                    // For a result, if all of its location types are deemed too imprecise, then this result is considered to be imprecise and an error is shown to the user.
                    for (let i = 0; i < features.length; i++) {
                        if (this.props.widgetConfig.invalidGeocodingResultTypes &&
                            features[i] &&
                            features[i].properties.placeData &&
                            features[i].properties.placeData.types) {
                            const types = features[i].properties.placeData.types;
                            features[i].properties.isGeocodingImprecise = types.every((e) => this.props.widgetConfig.invalidGeocodingResultTypes.includes(e));
                        }
                    }
                    const isSingleResultAndImpreciseGeocoding = this.props.widgetConfig.invalidGeocodingResultTypes &&
                        isSingleResult &&
                        features[0].properties.isGeocodingImprecise;
                    this.setState({
                        places: features,
                        selectedPlace: isSingleResult ? features[0] : undefined,
                        geocodingQueryString,
                        currentZoom: zoom,
                        // Display a message if there are no results
                        displayMessage: features && features.length === 0 ? 'main:InputMapGeocodeNoResult' : undefined
                    }, () => {
                        // FIXME: In order to directly show the "geocoding is imprecise" warning if there is a *single* result
                        // we must automatically confirm the place so that the validation code is executed.
                        // Ideally, we would not have to do this and we would be able to trigger the validation code directly
                        // from inside this react component.
                        if (isSingleResult && (this.autoConfirmIfSingleResult || isSingleResultAndImpreciseGeocoding)) {
                            this.onConfirmPlace(undefined);
                        }
                        else if (this.props.widgetConfig.invalidGeocodingResultTypes !== undefined) {
                            // Kind of a hack, but we must clear the value for this question when we do geocoding.
                            // For example, if you search for "montreal", you would get the "geocoding is imprecise" label in red.
                            // Then, if you search for "place ville marie" (a more specific place), you would see search results
                            // but STILL see the "geocoding is imprecise" error label since you haven't yet confirmed this location.
                            // This is weird and it seems to indicate to the user that this location is still not precise enough, which is not the case.
                            // Therefore, by clearing the value here, we get rid of any existing warning labels shown on the widget.
                            this.props.onValueChange({ target: { value: null } });
                        }
                    });
                    if ((!this.autoConfirmIfSingleResult || !isSingleResult) && !isSingleResultAndImpreciseGeocoding) {
                        this.shouldFitBoundsIdx++;
                    }
                }
                catch (error) {
                    surveyHelper.devLog(`Error geocoding places: ${error}`);
                    this.setState({ places: [], selectedPlace: undefined, displayMessage: 'main:InputMapGeocodeError' });
                }
                finally {
                    this.setState({ geocoding: false });
                }
            }
        });
        this.onMenuSelect = (e) => {
            const placeId = e && e.target ? e.target.value : null;
            if (placeId) {
                const selectedPlace = this.state.places.find((place) => place.properties.placeData.place_id === placeId);
                this.setState({ selectedPlace });
            }
        };
        this.onMarkerSelect = (feature) => {
            this.onValueChange(feature);
            this.setState({ selectedPlace: feature });
        };
        this.onConfirmPlace = (e) => {
            if (e) {
                e.preventDefault();
            }
            if (this.state.selectedPlace) {
                const selectedPlace = Object.assign({}, this.state.selectedPlace);
                const _a = this.state.selectedPlace.properties, { placeData } = _a, selectedPlaceProperties = __rest(_a, ["placeData"]);
                selectedPlace.properties = Object.assign({}, selectedPlaceProperties);
                selectedPlace.properties.lastAction = 'findPlace';
                selectedPlace.properties.geocodingQueryString = this.state.geocodingQueryString;
                selectedPlace.properties.geocodingResultsData = {
                    formatted_address: placeData.formatted_address,
                    place_id: placeData.place_id,
                    types: placeData.types
                };
                this.props.onValueChange({ target: { value: selectedPlace } });
                this.setState({
                    places: [],
                    selectedPlace: undefined,
                    defaultCenter: {
                        lat: selectedPlace.geometry.coordinates[1],
                        lon: selectedPlace.geometry.coordinates[0]
                    }
                });
            }
        };
        this.getInfoWindowContent = (place, showPhoto = false) => {
            return `
            <div>
              <div>
                ${place.properties.placeData.name}
              </div>
              <div class="_pale">${place.properties.placeData.formatted_address}</div>
              ${showPhoto && place.properties.placeData.photos && place.properties.placeData.photos[0]
                ? `<div><img src="${place.properties.placeData.photos[0].getUrl()}" height="100" /></div>`
                : ''}
            </div>`;
        };
        this.onSearchPlaceButtonMouseDown = this.onSearchPlaceButtonMouseDown.bind(this);
        this.onSearchPlaceButtonMouseUp = this.onSearchPlaceButtonMouseUp.bind(this);
        this.onSearchPlaceButtonKeyDown = this.onSearchPlaceButtonKeyDown.bind(this);
        // get initial map center from current value or widget config (can be a function)
        const defaultCenter = props.value
            ? { lon: props.value.geometry.coordinates[0], lat: props.value.geometry.coordinates[1] }
            : surveyHelper.parse(props.widgetConfig.defaultCenter, props.interview, props.path, props.user) ||
                project_config_1.default.mapDefaultCenter;
        this.autoConfirmIfSingleResult = this.props.widgetConfig.autoConfirmIfSingleResult || false;
        this.state = {
            geocoding: false,
            defaultCenter,
            places: [],
            searchPlaceButtonWasMouseDowned: false,
            geocodingSpecificOptions: {},
            renderGeoCodeButton: false
        };
    }
    componentDidUpdate(prevProps) {
        // wait for any field to blur (unfocus) and save and/or validate, then trigger click:
        if (this.props.loadingState === 0 &&
            prevProps.loadingState > 0 &&
            this.state.searchPlaceButtonWasMouseDowned === true) {
            // this is a hack because it will ignore mouseup if triggered and
            // will run clickButton even if the mouse was not upped.
            // but there is no other way to wait for blur to complete with fast clicks
            // (fast clicks with onBlur do not trigger mouseup)
            this.setState({ searchPlaceButtonWasMouseDowned: false }, this.onButtonFindPlaceClick);
        }
    }
    onSearchPlaceButtonMouseDown(_e) {
        //e.preventDefault();
        // preventing default would ignore active input blur
        this.setState({ searchPlaceButtonWasMouseDowned: true });
    }
    onSearchPlaceButtonMouseUp(e) {
        e.preventDefault();
        if (this.props.loadingState === 0) {
            this.setState({ searchPlaceButtonWasMouseDowned: false }, this.onButtonFindPlaceClick);
        }
    }
    onSearchPlaceButtonKeyDown(e) {
        e.preventDefault();
        if (e.key === 'enter' || e.key === 'space' || e.which === 13 || e.which === 32) {
            this.onButtonFindPlaceClick();
        }
    }
    render() {
        const maxZoom = this.props.widgetConfig.maxZoom || defaultMaxZoom;
        const places = this.state.places;
        const showSearchPlaceButton = this.props.widgetConfig.showSearchPlaceButton
            ? surveyHelper.parseBoolean(this.props.widgetConfig.showSearchPlaceButton, this.props.interview, this.props.path, this.props.user)
            : true;
        const searchPlaceButtonColor = this.props.widgetConfig.searchPlaceButtonColor
            ? surveyHelper.parseString(this.props.widgetConfig.searchPlaceButtonColor, this.props.interview, this.props.path, this.props.user)
            : 'green';
        const placesIconUrl = this.props.widgetConfig.placesIcon
            ? surveyHelper.parseString(this.props.widgetConfig.placesIcon.url, this.props.interview, this.props.path, this.props.user) || defaultMarkerUrl
            : defaultMarkerUrl;
        const placesIconSize = this.props.widgetConfig.placesIcon && this.props.widgetConfig.placesIcon.size
            ? this.props.widgetConfig.placesIcon.size
            : InputMapTypes_1.defaultIconSize;
        const selectedIconUrl = this.props.widgetConfig.selectedIcon
            ? surveyHelper.parseString(this.props.widgetConfig.selectedIcon.url, this.props.interview, this.props.path, this.props.user) || defaultSelectedMarkerUrl
            : defaultSelectedMarkerUrl;
        const selectedIconSize = this.props.widgetConfig.selectedIcon && this.props.widgetConfig.selectedIcon.size
            ? this.props.widgetConfig.selectedIcon.size
            : InputMapTypes_1.defaultIconSize;
        const iconUrl = this.props.widgetConfig.icon
            ? surveyHelper.parseString(this.props.widgetConfig.icon.url, this.props.interview, this.props.path, this.props.user) || defaultMarkerUrl
            : defaultMarkerUrl;
        const iconSize = this.props.widgetConfig.icon && this.props.widgetConfig.icon.size
            ? this.props.widgetConfig.icon.size
            : InputMapTypes_1.defaultIconSize;
        const placeMenuChoices = places.map((place) => {
            const placeData = place.properties.placeData;
            return {
                value: placeData.place_id,
                label: placeData.types && placeData.types.length === 1 && placeData.types[0] === 'street_address'
                    ? placeData.formatted_address
                    : `${placeData.name} (${placeData.formatted_address})`
            };
        });
        const markers = [];
        if (places && places.length > 0) {
            places.forEach((feature) => markers.push({
                position: feature,
                icon: {
                    url: feature === this.state.selectedPlace ? selectedIconUrl : placesIconUrl,
                    size: feature === this.state.selectedPlace ? selectedIconSize : placesIconSize
                },
                draggable: this.state.selectedPlace ? true : false,
                onClick: () => this.onMarkerSelect(feature)
            }));
        }
        if (this.props.value) {
            markers.push({
                position: this.props.value,
                icon: { url: iconUrl, size: iconSize },
                draggable: true
            });
            if (this.props.value.properties.lastAction && this.props.value.properties.lastAction === 'shortcut') {
                // Since this block of code runs when the map is given an initial value (for example when a shortcut is chosen),
                // we need to update the map bounds.
                this.shouldFitBoundsIdx++;
            }
        }
        const infoWindow = this.state.selectedPlace
            ? {
                position: this.state.selectedPlace,
                content: this.getInfoWindowContent(this.state.selectedPlace, this.props.widgetConfig.showPhoto)
            }
            : undefined;
        const afterRefreshButtonText = this.props.widgetConfig.afterRefreshButtonText
            ? surveyHelper.translateString(this.props.widgetConfig.afterRefreshButtonText, this.props.i18n, this.props.interview, this.props.path, this.props.user)
            : null;
        return (react_1.default.createElement("div", { className: 'survey-question__input-map-container' },
            react_1.default.createElement("input", { type: "hidden", className: 'apptr__form-input input-map-hidden', name: this.props.widgetConfig.shortname, id: this.props.id, defaultValue: JSON.stringify(this.props.value), readOnly: true, ref: this.props.inputRef }),
            this.props.widgetConfig.refreshGeocodingLabel && showSearchPlaceButton !== false && (react_1.default.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                } },
                react_1.default.createElement("button", { id: `${this.props.id}_refresh`, type: "button", className: `button refresh-geocode ${searchPlaceButtonColor} large`, onMouseDown: this.onSearchPlaceButtonMouseDown, onMouseUp: this.onSearchPlaceButtonMouseUp, onKeyDown: this.onSearchPlaceButtonKeyDown, ref: this.geocodeButtonRef, style: { display: this.state.renderGeoCodeButton ? 'inline' : 'none' } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faMapMarkerAlt_1.faMapMarkerAlt, className: "faIconLeft" }),
                    surveyHelper.translateString(this.props.widgetConfig.refreshGeocodingLabel, this.props.i18n, this.props.interview, this.props.path, this.props.user)),
                react_1.default.createElement("div", { style: { marginLeft: 10 } },
                    react_1.default.createElement(HashLoader_1.default, { size: 30, color: '#aaaaaa', loading: this.state.geocoding })))),
            this.state.displayMessage && (react_1.default.createElement(SurveyErrorMessage_1.default, { containsHtml: false, text: this.props.t(this.state.displayMessage) })),
            places.length > 0 && (react_1.default.createElement("p", { className: "_strong _dark" }, this.props.t(places.length > 1 ? 'main:SelectPlaceText' : 'main:SelectPlaceTextSingleResult'))),
            places.length >= 1 && (react_1.default.createElement("div", null,
                react_1.default.createElement("label", { htmlFor: 'survey-question__input-multiselect-' + this.props.path + '_mapFindPlaceMenu', style: { display: 'none' } }, this.props.t('main:SelectPlaceResultsLabel')),
                react_1.default.createElement(InputSelect_1.default, { choices: placeMenuChoices, value: this.state.selectedPlace && this.state.selectedPlace.properties.placeData.place_id
                        ? this.state.selectedPlace.properties.placeData.place_id
                        : undefined, onValueChange: this.onMenuSelect, id: `${this.props.id}_mapFindPlace` }),
                react_1.default.createElement("div", { className: "apptr__separator" }))),
            afterRefreshButtonText && this.props.widgetConfig.containsHtml ? (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: afterRefreshButtonText } })) : (react_1.default.createElement(react_markdown_1.default, { remarkPlugins: [[remark_gfm_1.default, { singleTilde: false }]] }, afterRefreshButtonText)),
            react_1.default.createElement("div", { "aria-hidden": "true", className: "survey-question__input-map-container" },
                react_1.default.createElement(InputMapGoogle_1.default, { defaultCenter: this.state.defaultCenter, maxGeocodingResultsBounds: this.getMaxGeocodingResultsBounds(), value: this.props.value, onValueChange: this.onValueChange, height: this.props.widgetConfig.height, defaultZoom: Math.min(this.state.currentZoom || this.props.widgetConfig.defaultZoom || defaultZoom, maxZoom), maxZoom: maxZoom, markers: markers, onMapReady: this.onMapReady, onBoundsChanged: this.onBoundsChanged, shouldFitBounds: this.shouldFitBoundsIdx, infoWindow: infoWindow, setGeocodingOptions: this.setGeocodingOptions })),
            this.state.selectedPlace && places.length > 0 && (react_1.default.createElement("div", { className: "center" }, this.props.widgetConfig.refreshGeocodingLabel && (react_1.default.createElement("button", { id: `${this.props.id}_confirm`, type: "button", className: "button green", onClick: this.onConfirmPlace },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faCheckCircle_1.faCheckCircle, className: "faIconLeft" }),
                this.props.t('main:ConfirmLocation')))))));
    }
}
exports.InputMapFindPlace = InputMapFindPlace;
exports.default = (0, react_i18next_1.withTranslation)()(InputMapFindPlace);
//# sourceMappingURL=InputMapFindPlace.js.map